import { CaseLocationUnsafeMock } from './Case';
import { CaseGamerPicMock } from './Case_GamerPic';
import { CaseAudioMock } from './Case_Audio';
import { CaseTextMock } from './Case_Text';
import { CaseVideoMock } from './Case_Video';
import { CaseChatMock } from './Case_Json';
import { CaseChatTestMock } from './Case_Json';
import { CaseStreamingMock } from './Case_Livestream';
import { CaseIdentityMock } from './Case_Json_Id';
import { CaseClubProfileMock } from './Case_ClubProfile';
import { CaseImageJsonTestMock } from './Image_Carousel_Json';
import { Case } from 'services';

export const CaseModel: Case = {
  id: '',
  tenant: {
    displayName: '',
    tenantId: '',
    stackingConfigurationByTitleId: {}
  },
  title: {
    displayName: '',
    titleId: ''
  },
  subject: {
    subjectId: '',
    subjectType: '',
    subjectValue: undefined,
    subjectLabels: undefined,
    subjectOwners: undefined,
    subjectHashes: undefined,
    subjectMetadata: undefined
  },
  caseEvidence: {
    key: '',
    value: ''
  },
  caseCreationDateTime: '',
  caseAssignedStartTime: '',
  caseClosedDateTime: '',
  status: '',
  caseContext: {},
  opinion: {},
  caseActions: [],
  feedbacks: [],
  groundTruthCaseActions: false,
  outOfSla: false
};

export const MockCases: Case[] = CaseLocationUnsafeMock.concat(
  CaseGamerPicMock,
  CaseAudioMock,
  CaseTextMock,
  CaseVideoMock,
  CaseChatMock,
  CaseChatTestMock,
  CaseStreamingMock,
  CaseIdentityMock,
  CaseClubProfileMock,
  CaseImageJsonTestMock
);
